/*
  Order form: date picker, validation and cart guard.
  Loaded on every page (layout/theme.liquid) so the product page and the cart share
  exactly the same date rules.

  Date rules come from data attributes rendered by snippets/order-form-rules.liquid:
    data-cutoff="16:00"  data-lead="1"  data-max="90"
    data-blocked-days="0,"  data-blocked-dates="2026-12-25,"
  All dates are worked out in UK time (Europe/London), whatever the shopper's clock says.
*/
(function () {
  if (window.OrderForm) return;

  var TZ = 'Europe/London';
  var DAY = 86400000;
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  /* ---------- Shared date rules ---------- */
  function ukNow() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { date: Date.UTC(+p.year, +p.month - 1, +p.day), minutes: (+p.hour % 24) * 60 + (+p.minute) };
  }
  function iso(d) { return new Date(d).toISOString().slice(0, 10); }
  function fromIso(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : null;
  }
  function longDate(d) { return new Date(d).toLocaleDateString('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }); }

  function Rules(el) {
    var cp = (el.dataset.cutoff || '16:00').split(':');
    this.cutoff = (parseInt(cp[0], 10) || 0) * 60 + (parseInt(cp[1], 10) || 0);
    var lead = parseInt(el.dataset.lead, 10);
    this.lead = isNaN(lead) ? 1 : Math.max(lead, 0);
    this.maxAhead = Math.max(parseInt(el.dataset.max, 10) || 90, 1);
    this.blockedDays = (el.dataset.blockedDays || '').split(',').filter(Boolean).map(Number);
    this.blockedDates = (el.dataset.blockedDates || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  Rules.prototype.bounds = function () {
    var now = ukNow();
    var earliest = now.date + this.lead * DAY + (now.minutes >= this.cutoff ? DAY : 0);
    if (earliest < now.date) earliest = now.date;
    return { today: now.date, earliest: earliest, latest: now.date + this.maxAhead * DAY };
  };
  Rules.prototype.allowed = function (d, b) {
    b = b || this.bounds();
    if (d === null || d < b.earliest || d > b.latest) return false;
    if (this.blockedDays.indexOf(new Date(d).getUTCDay()) > -1) return false;
    return this.blockedDates.indexOf(iso(d)) === -1;
  };
  Rules.prototype.firstAllowed = function (b) {
    b = b || this.bounds();
    for (var d = b.earliest; d <= b.latest; d += DAY) if (this.allowed(d, b)) return d;
    return null;
  };

  /* ---------- Date picker ---------- */
  function initDate(wrap) {
    if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
    var rules = new Rules(wrap);
    var input = wrap.querySelector('.order-field__date-input');
    var isoInput = wrap.querySelector('[data-date-iso]');
    var cal = wrap.querySelector('[data-cal]');
    var view = null, b = null;

    function selected() { return fromIso(isoInput && isoInput.value); }
    function setDate(d) {
      input.value = d === null ? '' : longDate(d);
      if (isoInput) isoInput.value = d === null ? '' : iso(d);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    wrap._orderFormRules = rules;
    wrap._orderFormSelected = selected;
    wrap._orderFormClear = function () { setDate(null); };

    function render() {
      var v = new Date(view), y = v.getUTCFullYear(), m = v.getUTCMonth();
      var first = Date.UTC(y, m, 1), days = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
      var offset = (new Date(first).getUTCDay() + 6) % 7; // Monday first
      var e = new Date(b.earliest), l = new Date(b.latest), sel = selected();
      var canPrev = first > Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), 1);
      var canNext = first < Date.UTC(l.getUTCFullYear(), l.getUTCMonth(), 1);
      var h = '<div class="order-cal__head"><button type="button" class="order-cal__nav" data-nav="-1" aria-label="Previous month"' + (canPrev ? '' : ' disabled') + '>&#8249;</button>' +
        '<span class="order-cal__title">' + MONTHS[m] + ' ' + y + '</span>' +
        '<button type="button" class="order-cal__nav" data-nav="1" aria-label="Next month"' + (canNext ? '' : ' disabled') + '>&#8250;</button></div><div class="order-cal__grid">';
      ['Mo','Tu','We','Th','Fr','Sa','Su'].forEach(function (d) { h += '<span class="order-cal__dow">' + d + '</span>'; });
      for (var i = 0; i < offset; i++) h += '<span></span>';
      for (var n = 1; n <= days; n++) {
        var d = Date.UTC(y, m, n), ok = rules.allowed(d, b);
        h += '<button type="button" class="order-cal__day' + (d === b.today ? ' is-today' : '') + (d === sel ? ' is-selected' : '') + '" data-day="' + d + '"' +
          (ok ? '' : ' disabled') + ' aria-label="' + longDate(d) + (ok ? '' : ' (unavailable)') + '">' + n + '</button>';
      }
      h += '</div>';
      var fa = rules.firstAllowed(b);
      h += '<p class="order-cal__note">' + (fa ? 'Earliest available: ' + longDate(fa) : 'No dates are available at the moment.') + '</p>';
      cal.innerHTML = h;
    }
    /* Open below the field if the calendar fits there, otherwise above it, otherwise below and scroll it into view. */
    function place() {
      if (cal.hidden) return;
      cal.classList.remove('order-cal--up');
      var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      var r = input.getBoundingClientRect(), h = cal.offsetHeight + 8;
      var below = vh - r.bottom, above = r.top;
      if (h > below && h <= above) { cal.classList.add('order-cal--up'); return; }
      if (h > below) {
        var c = cal.getBoundingClientRect();
        window.scrollBy({ top: c.bottom - vh + 12, behavior: 'smooth' });
      }
    }
    function open() {
      b = rules.bounds();
      if (selected() !== null && !rules.allowed(selected(), b)) setDate(null);
      var base = selected() || rules.firstAllowed(b) || b.earliest, bd = new Date(base);
      view = Date.UTC(bd.getUTCFullYear(), bd.getUTCMonth(), 1);
      render(); cal.hidden = false; input.setAttribute('aria-expanded', 'true');
      place();
      var f = cal.querySelector('.is-selected') || cal.querySelector('.order-cal__day:not(:disabled)');
      if (f) f.focus({ preventScroll: true });
    }
    function close(refocus) { cal.hidden = true; input.setAttribute('aria-expanded', 'false'); if (refocus) input.focus(); }

    input.addEventListener('click', function () { cal.hidden ? open() : close(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); open(); } });
    cal.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-nav]'), day = e.target.closest('[data-day]');
      if (nav && !nav.disabled) {
        var v = new Date(view); view = Date.UTC(v.getUTCFullYear(), v.getUTCMonth() + (+nav.dataset.nav), 1); render(); place();
        var again = cal.querySelector('[data-nav="' + nav.dataset.nav + '"]:not([disabled])'); if (again) again.focus({ preventScroll: true });
      } else if (day && !day.disabled) {
        setDate(+day.dataset.day); close(true);
      }
    });
    cal.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
    document.addEventListener('click', function (e) {
      // The month arrows re-draw the calendar, which detaches the clicked button, so check the event's original path.
      var path = e.composedPath ? e.composedPath() : [];
      var inside = path.indexOf(wrap) > -1 || wrap.contains(e.target);
      if (!cal.hidden && !inside) close();
    });
  }

  /* ---------- Product page validation ---------- */
  function fieldValue(f) {
    if (f.dataset.type === 'choice-buttons') { var c = f.querySelector('input:checked'); return c ? c.value : ''; }
    var el = f.querySelector('.order-field__input'); return el ? el.value.trim() : '';
  }
  function setError(f, msg) {
    var e = f.querySelector('[data-error]');
    f.classList.toggle('is-invalid', !!msg);
    if (e) { if (msg) e.textContent = msg; e.hidden = !msg; }
  }
  function validate(formId) {
    var bad = [];
    document.querySelectorAll('[data-order-field][data-form="' + formId + '"]').forEach(function (f) {
      var msg = '';
      var errEl = f.querySelector('[data-error]');
      var defaultMsg = (errEl && errEl.getAttribute('data-default')) || 'Please complete this field';
      if (f.dataset.type === 'date-picker') {
        var wrap = f.querySelector('[data-datepicker]');
        var d = wrap && wrap._orderFormSelected ? wrap._orderFormSelected() : null;
        if (d !== null && wrap._orderFormRules && !wrap._orderFormRules.allowed(d)) {
          // e.g. the page was left open past the cut-off
          wrap._orderFormClear();
          msg = 'That date is no longer available. Please choose another date.';
        } else if (d === null && f.hasAttribute('data-required')) {
          msg = defaultMsg;
        }
      } else if (f.hasAttribute('data-required') && !fieldValue(f)) {
        msg = defaultMsg;
      }
      setError(f, msg);
      if (msg) bad.push(f);
    });
    if (bad.length) {
      bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = bad[0].querySelector('.order-field__input, input');
      if (first && bad[0].dataset.type !== 'date-picker') setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
    }
    return !bad.length;
  }
  function formHasOrderFields(formId) { return !!(formId && document.querySelector('[data-order-field][data-form="' + formId + '"]')); }

  document.addEventListener('submit', function (e) {
    var formId = e.target.getAttribute && e.target.getAttribute('id'); // never form.id: Shopify forms contain an input named "id"
    if (!formHasOrderFields(formId)) return;
    if (!validate(formId)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    // Leave unanswered optional fields out of the order rather than sending blank lines.
    var off = [];
    document.querySelectorAll('[form="' + formId + '"].order-field__input, [form="' + formId + '"][data-date-iso]').forEach(function (el) {
      if (!el.value.trim() && !el.disabled) { el.disabled = true; off.push(el); }
    });
    setTimeout(function () { off.forEach(function (el) { el.disabled = false; }); }, 0);
  }, true);

  // "Buy it now" skips the form's submit event, so check on click too.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.shopify-payment-button');
    if (!btn) return;
    var form = btn.closest('form'); var formId = form && form.getAttribute('id');
    if (formHasOrderFields(formId) && !validate(formId)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  function onEdit(e) {
    var f = e.target.closest && e.target.closest('[data-order-field]'); if (!f) return;
    if (f.classList.contains('is-invalid') && fieldValue(f)) setError(f, '');
    if (e.target.tagName === 'SELECT') e.target.classList.toggle('is-empty', !e.target.value);
    if (e.target.hasAttribute('data-counter')) {
      var out = f.querySelector('[data-counter-out]'); if (out) out.textContent = e.target.value.length + ' / ' + e.target.maxLength;
    }
  }
  document.addEventListener('input', onEdit);
  document.addEventListener('change', onEdit);

  /* ---------- Cart guard ---------- */
  // Each cart line that needs an order form renders [data-order-line] (snippets/order-line-check.liquid).
  function lineProblem(line) {
    if (+line.dataset.missing > 0) return 'missing';
    if (line.dataset.hasDate === 'true') {
      var d = fromIso(line.dataset.dateIso);
      if (d === null) return 'missing';
      if (!new Rules(line).allowed(d)) return 'date';
    }
    return '';
  }
  function checkCart(show) {
    var bad = [];
    document.querySelectorAll('[data-order-line]').forEach(function (line) {
      var problem = lineProblem(line);
      line.querySelectorAll('[data-problem]').forEach(function (p) { p.hidden = !(show && p.dataset.problem === problem); });
      line.hidden = !(show && problem);
      if (problem) bad.push(line);
    });
    return bad;
  }
  function blockCheckout(e) {
    var bad = checkCart(true);
    if (!bad.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (t) blockCheckout(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    var action = (e.target.getAttribute('action') || '');
    if ((s && s.name === 'checkout') || /\/checkout(\?|$)/.test(action)) blockCheckout(e);
  }, true);

  /* ---------- Boot ---------- */
  function init() {
    document.querySelectorAll('[data-datepicker]').forEach(initDate);
    document.querySelectorAll('.order-field__select-wrap select').forEach(function (s) { s.classList.toggle('is-empty', !s.value); });
    checkCart(true);
  }
  window.OrderForm = { init: init, Rules: Rules, checkCart: checkCart };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // The cart drawer and quick view re-render their HTML; re-run checks when they do.
  var pending = null;
  new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(init, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
